import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { useEventListener } from 'src/core/hooks/useEventListener';
import { Button } from 'src/shared/components/button';
import { Icon } from 'src/shared/components/icon';
export function DropdownControl({ children, ...rest }) {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);
    useEventListener('openDropdown', (event) => {
        if (event.target.contains(ref.current))
            setIsOpen(true);
    });
    useEventListener('closeDropdown', (event) => {
        if (event.target.contains(ref.current))
            setIsOpen(false);
    });
    return (_jsxs(Button, { ...rest, ref: ref, children: [children, _jsx(Icon, { icon: isOpen ? faChevronUp : faChevronDown })] }));
}
